import React from "react";
import { useTab } from "../../../contexts/tab";
import TabBodyLabelSize from "./TabBodyLabelSize";
import TabBodyCore from "./TabBodyCore";
import TabBodyPaper from "./TabBodyPaper";
import TabBodyPaperSize from "./TabBodyPaperSize";
import TabBodyColor from "./TabBodyColor";
import TabBodyUps from "./TabBodyUps";

export default function TabBody() {
  const [{ activeTab }] = useTab();
  switch (activeTab) {
    case 0:
      return <TabBodyLabelSize />;
    case 1:
      return <TabBodyCore />;
    case 2:
      return <TabBodyPaper />;
    case 3:
      return <TabBodyPaperSize />;
    case 4:
      return <TabBodyColor />;
    case 5:
      return <TabBodyUps />;
    default:
      return (
        <div className="border border-red-900">
          <div>Default Tab Body {activeTab}</div>
        </div>
      );
  }
}
